var React = require('react');

function IcShareTwDark (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M32.242 12.286c-.88.4-1.828.663-2.811.788a4.912 4.912 0 002.148-2.72c-.948.572-2 .972-3.108 1.2-.903-.983-2.172-1.554-3.612-1.554-2.686 0-4.88 2.194-4.88 4.903 0 .388.046.766.126 1.12a13.937 13.937 0 01-10.103-5.12 4.85 4.85 0 00-.663 2.457c0 1.703.857 3.211 2.183 4.069-.811 0-1.566-.229-2.229-.572v.034a4.907 4.907 0 003.932 4.812 4.827 4.827 0 01-2.206.08c.617 1.931 2.412 3.371 4.572 3.406a9.739 9.739 0 01-6.092 2.102c-.388 0-.777-.022-1.165-.068a13.88 13.88 0 007.52 2.206c9.005 0 13.954-7.475 13.954-13.955 0-.217 0-.423-.012-.64a9.796 9.796 0 002.446-2.548z","fill":"#000"}));
}

IcShareTwDark.defaultProps = {"width":"40","height":"40","fill":"none"};

module.exports = IcShareTwDark;

IcShareTwDark.default = IcShareTwDark;
